import { storeToRefs } from 'pinia';
import type { Ref } from 'vue';
import { computed } from 'vue';
import BetGeniusStream from '@/components/liveStream/betGeniusStream/BetGeniusStream.vue';
import type { UseLiveStreamEvent, UseLiveStreamProvider } from '@/composable/liveStream/useLiveStream';
import { LiveStreamProvider } from '@/interface/enum';
import { useCustomerStore } from '@/store/customerStore';

export function useBetGeniusStream(event: Ref<UseLiveStreamEvent | null>): UseLiveStreamProvider {
    const { ipCountryCode } = storeToRefs(useCustomerStore());

    const isAvailable = computed(() => !!event.value?.stream?.betGenius?.allowedCountries?.includes(ipCountryCode.value));

    const isPlayable = computed(() => isAvailable.value && !!event.value?.stream?.betGenius?.isPlaying);

    const streamDisplay = computed(() => {
        if (!isPlayable.value || !event.value?.stream?.betGenius) return null;

        return {
            provider: LiveStreamProvider.BetGenius,
            component: BetGeniusStream,
            key: event.value.stream.betGenius.eventId.toString(),
            props: {
                betGenius: event.value.stream.betGenius,
            },
        };
    });

    return {
        isAvailable,
        isPlayable,
        streamDisplay,
    };
}
